export const getters = {
  list: (state: any) => state.list,
  sales: (state: any) => state.sales,
  hourly: (state: any) => state.hourly,
  sku: (state: any) => state.sku,
  collection: (state: any) => state.collection
}
